module.exports = __webpack_public_path__ + "assets/570f263f6eb97d8a5e36ad8d11696d85.png";